import { Compass } from 'lucide-react';

/** Default Concierge helper — keyword routing, no persona avatar. */
export function ConciergeHelperIcon({
  size = 28,
  className = '',
}: {
  size?: number;
  className?: string;
}) {
  return (
    <span
      className={`inline-flex flex-shrink-0 items-center justify-center rounded-full bg-[var(--slate-dim)] text-[var(--text-sec)] dark:bg-[var(--active-tint)] dark:text-[#8EA7D8] ${className}`}
      style={{ width: size, height: size }}
    >
      <Compass style={{ width: Math.round(size * 0.5), height: Math.round(size * 0.5) }} />
    </span>
  );
}

export function ConciergeHelperHeaderIcon({ className = 'h-4 w-4 shrink-0' }: { className?: string }) {
  return <Compass className={className} aria-hidden />;
}
